import { useContext } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import UserProfile from './components/UserProfile';
import Loading from '../../components/ui/Loading';
import { useGetUserProfileQuery } from '../../store/api/userApi';
import { extractIdFromURL } from '../../utils/common';
import NotesCardGroup from '../../components/shared/RelatedNoteSection/NotesCardGroup';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/auth/authSlice';
import { AppContext } from '../../context/ContextProvider';

function UserProfilePage() {
  const currentUserId = useSelector(selectUser);
  const location = useLocation();
  const { isLogin } = useContext(AppContext);
  const id = extractIdFromURL(location.pathname)
    ? extractIdFromURL(location.pathname)
    : currentUserId;
  const { data: user, isLoading } = useGetUserProfileQuery(id);
  if (isLoading) return <Loading />;
  if (!user) return <Navigate to="/notfound" replace />;
  const isOwner = currentUserId === user.data.user._id && isLogin;

  return (
    <>
      <UserProfile {...user.data.user} />
      <NotesCardGroup
        displayName={user.data.user.userName}
        noteCardData={user.data.user.postedNotes}
        savedNotesData={user.data.user.savedNotes}
        typeofTitle="Notes by"
        isOwnerTabs={isOwner ? true : false}
      />
    </>
  );
}

export default UserProfilePage;
